import React, {useContext} from 'react';
//import {ConfigurationContext} from '../../Context/Configuration';
import styles from './NonVRSiteGridItem.module.css'

const NonVRSiteGridItem=(props)=>{
    //const [config, update]=useContext(ConfigurationContext);
    // const site = props.site;
    // const tour = config.tours[site.vtourid];  

    return (
        <div className={styles.layout}>
            <div className={styles.details}>
                <div className={styles.description}>
                    <div className={styles.description_text} >
                    Every season starts with a clean slate – that is, if weeds aren’t already in the field before you seed. Set the scene for success and wipe the slate clean with a pre-seed herbicide application that targets the weed populations in your fields.
                    </div>
               </div>                
            </div>
        </div>
    )
};

export default NonVRSiteGridItem;
